// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Menu_wrapper__3jCi5","isCollapsed":"Menu_isCollapsed__30a4g"};